import React from "react";
import { TestBox, CheckResult } from "../index";
import PropTypes from "prop-types";
import I18N from "../../I18N";

const ScoreCameraInfo = ({ cameraInfo, handleReTest }) => {
  const { hasPerspectiveCoords } = cameraInfo;
  return (
    <TestBox testName={I18N.t("SCORE_CAMERA")} handleReTest={handleReTest}>
      <div style={{marginTop: '20px'}}>
        <p>{I18N.t("PERSPECTIVE_COORDS")}</p>
        <CheckResult isSuccess={hasPerspectiveCoords} />
      </div>
    </TestBox>
  );
};

ScoreCameraInfo.propTypes = {};
ScoreCameraInfo.defaultProps = {};

export default ScoreCameraInfo;
